import { render, staticRenderFns } from "./TaxStatements.vue?vue&type=template&id=8714b2a6&scoped=true&"
import script from "./TaxStatements.vue?vue&type=script&lang=js&"
export * from "./TaxStatements.vue?vue&type=script&lang=js&"
import style0 from "./TaxStatements.vue?vue&type=style&index=0&id=8714b2a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8714b2a6",
  null
  
)

export default component.exports